/**
 * Store admin — buyer detail (Commerce, M3).
 *
 * @see apps/web/src/features/store/buyers/buyer-detail-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { BuyerDetailPage } from "../../../../../../features/store/buyers/buyer-detail-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/buyers/$buyerId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { buyerId } = Route.useParams();
  return <BuyerDetailPage buyerId={buyerId} />;
}
